import { h } from 'preact';
import styles from './style.css';
import cx from 'classnames';

const WhatItDoes = () => (
	<div
		className={cx(
			styles.whatItDoes,
			'flex',
			'flex-col',
			'items-center',
			'justify-center',
			'flex-wrap'
		)}
	>
		<div>
			<div className={'labelBoxLine self-start'} style={{ width: '200px' }} />
			<div className={styles.descriptiveText}>
				This disruptive product takes sports betting to a new level. Operators can
				offer 24/7 betting opportunities on an unlimited combination of results,
				getting an edge on competitors by offering a unique customer experience.
				<br />
				This is the future of betting.
			</div>
		</div>
		<div className={'flex'} style={{ width: '100%' }}>
			<div
				className={cx(
					styles.mainGameContainer,
					'flex',
					'flex-col',
					'items-center',
					'flex-1'
				)}
			>
				<div style={{ paddingBottom: '30px', zIndex: '100' }}>
					<img src={'/assets/whatItDoes/kickOffIcon.png'} />
				</div>
				<div
					class="sectionHead"
					style={{ paddingBottom: '40px', zIndex: '100' }}
				>
					KICK-OFF
				</div>
				<div
					className={cx(styles.innerGameContainer, 'flex', 'justify-between')}
				>
					<div
						className={cx(styles.imageColums, 'flex', 'flex-col', 'items-end')}
						style={{ textAlign: 'right' }}
					>
						<div className={'flex'}>
							<img src={'/assets/whatItDoes/blueShirtLarge.svg'} />
						</div>
						<div
							className={'labelBoxLine self-end'}
							style={{ marginTop: '320px' }}
						/>
						<div className={cx(styles.bigNumber, 'flex')}>80</div>
						<div className={cx(styles.titleText, 'flex')}>
							LIVE UPDATES PER GAME
						</div>
						<div className={cx(styles.subText, 'flex')}>
							With around 80 live updates per game, customers can watch the
							value of their bet go up and down almost every time their chosen
							player is involved in the action.
						</div>
					</div>
					<div className={cx(styles.gameEvents, 'flex', 'flex-col')}>
						<div
							className={'flex flex-col flex-1'}
							style={{
								backgroundImage:
									'URL(/assets/whatItDoes/ballShapeGradient.png)',
								backgroundPosition: 'center 420px',
								backgroundRepeat: 'no-repeat'
							}}
						>
							<div className={'flex flex-col flex-1'}>
								<GameEvent style={{ minHeight: '20px' }} />
								<GameEvent
									minute="13'"
									text="In this half plenty of possession for Chelsea."
									points=""
									gameEventSimple
								/>
								<GameEvent
									minute="18'"
									text="John wins a free-kick for Liverpool."
									points="+5"
									gameEventIncrease
								/>
								<GameEvent
									minute="18'"
									text="Yellow card for Peter."
									points="-10"
									gameEventYellowCard
								/>
								<GameEvent
									minute="29'"
									text="Incomplete pass from Joseph"
									points="-1"
									gameEventDecrease
								/>
								<GameEvent
									minute="43'"
									text="Assist for goal from the magic John"
									points="+50"
									gameEventIncrease
								/>
								<GameEvent style={{ minHeight: '20px' }} />
							</div>
							<div
								className={'flex flex-col'}
								style={{
									fontWeight: '500',
									letterSpacing: '2.25px',
									lineHeight: '15px',
									height: '320px'
								}}
							>
								<div
									className={'flex self-center'}
									style={{ marginTop: '10px', opacity: '0.4' }}
								>
									WHAT A GOAL!
								</div>
								<div
									className={'flex flex-1'}
									style={{
										backgroundImage: 'URL(/assets/whatItDoes/shirts.png)',
										backgroundPosition: 'top center',
										backgroundRepeat: 'no-repeat',
										backgroundSize: 'contain',
										marginTop: '35px'
									}}
								/>
								<div
									className={'flex self-center'}
									style={{
										color: '#50E373',
										fontSize: '20px',
										fontWeight: 'bold',
										letterSpacing: '1.45px',
										lineHeight: '19px',
										paddingTop: '20px'
									}}
								>
									+ 100
								</div>
								<div
									className={'flex items-center self-center'}
									style={{
										color: '#FFFFFF',
										fontSize: '16px',
										fontWeight: 'bold',
										letterSpacing: '1.45px',
										lineHeight: '19px',
										paddingTop: '10px',
										height: '80px'
									}}
								>
									BET ON PLAYER
								</div>
							</div>
						</div>
					</div>
					<div
						className={cx(
							styles.imageColums,
							'flex',
							'flex-col',
							'items-start'
						)}
					>
						<div className={'flex'}>
							<img src={'/assets/whatItDoes/redShirtLarge.svg'} />
						</div>
						<div className={'labelBoxLine'} style={{ marginTop: '320px' }} />
						<div className={cx(styles.bigNumber, 'flex')}>42</div>
						<div className={cx(styles.titleText, 'flex')}>WAYS TO SCORE</div>
						<div className={cx(styles.subText, 'flex')}>
							With 42 ways a player can gain or lose points, every single time a
							player is involved in the game, it is going to impact his
							in-running score.
						</div>
					</div>
				</div>
				<div
					style={{
						paddingTop: '10px',
						paddingBottom: '30px',
						color: '#FFFFFF',
						opacity: '0.4',
						fontWeight: '500',
						lineHeight: '15px'
					}}
				>
					PLAY ON ANY DEVICE
				</div>
				<div className={'flex justify-between'} style={{ width: '150px' }}>
					<img src={'/assets/whatItDoes/tablet.png'} />
					<img src={'/assets/whatItDoes/computer.png'} />
					<img src={'/assets/whatItDoes/phone.png'} />
				</div>
			</div>
			<div
				className={'labelBoxLineContainer flex justify-between flex-row'}
				style={{ backgroundColor: '#F2F2F2' }}
			>
				<div
					className={cx(styles.imageColums, 'flex', 'flex-col', 'items-start')}
					style={{ marginLeft: '20px', marginRight: '10px', marginTop: '20px' }}
				>
					<div className={cx(styles.bigNumber, 'flex')}>80</div>
					<div className={'labelBoxLine'} />
					<div
						className={cx(styles.titleText, 'flex')}
						style={{ color: '#03060F' }}
					>
						LIVE UPDATES PER GAME
					</div>
					<div
						className={cx(styles.subText, 'flex')}
						style={{ color: '#03060F' }}
					>
						With around 80 live updates per game, customers can watch the value
						of their bet go up and down almost every time their chosen player is
						involved in the action.
					</div>
				</div>
				<div
					className={cx(styles.imageColums, 'flex', 'flex-col', 'items-start')}
					style={{ marginLeft: '10px', marginRight: '20px', marginTop: '20px' }}
				>
					<div className={cx(styles.bigNumber, 'flex')}>42</div>
					<div className={'labelBoxLine'} />
					<div
						className={cx(styles.titleText, 'flex')}
						style={{ color: '#03060F' }}
					>
						WAYS TO SCORE
					</div>
					<div
						className={cx(styles.subText, 'flex')}
						style={{ color: '#03060F' }}
					>
						With 42 ways a player can gain or lose points, every single time a
						player is involved in the game, it is going to impact his in-running
						score.
					</div>
				</div>
			</div>
		</div>
	</div>
);

function GameEvent(props) {
	let eventLine = cx(styles.gameEventLine, 'flex', {
		[styles.gameEventSimple]: props.gameEventSimple,
		[styles.gameEventIncrease]: props.gameEventIncrease,
		[styles.gameEventDecrease]: props.gameEventDecrease,
		[styles.gameEventYellowCard]: props.gameEventYellowCard
	});
	return (
		<div
			className={cx(styles.gameEvent, 'flex', 'flex-row')}
			style={props.style}
		>
			<div className={eventLine} />
			<div className={cx(styles.gameEventMinutes, 'flex')}>{props.minute}</div>
			<div className={cx(styles.gameEventText, 'flex', 'flex-col', 'flex-1')}>
				<div className={'flex'}>{props.text}</div>
				{props.points &&
					props.points.length > 0 && (
						<div
							className={cx('flex')}
							style={{
								color: props.points.charAt(0) == '-' ? '#D11F3C' : '#50E373'
							}}
						>
							{props.points} PTS
					</div>
					)}
			</div>
		</div>
	);
}

export default WhatItDoes;



// WEBPACK FOOTER //
// ./components/WhatItDoes/index.jsx